const getAll = messages => messages;
const getRead = messages => messages.filter(message => message.seen === true);
const getUnread = messages =>
  messages.filter(message => message.seen === false);
const getFlagged = messages =>
  messages.filter(message => message.flagged === true);
const getUserSearch = (messages, searchTerm, filteredMessages) =>
  messages.filter(message => {
    if (
      message &&
      message.subject &&
      message.from &&
      message.from.length &&
      searchTerm
    ) {
      return (
        message.subject.toUpperCase().indexOf(searchTerm.toUpperCase()) !==
          -1 ||
        message.from[0].toUpperCase().indexOf(searchTerm.toUpperCase()) !==
          -1 ||
        message.recipients.filter(re =>
          re.address.toUpperCase().includes(searchTerm.toUpperCase())
        ).length > 0 ||
        filteredMessages?.includes(message.messageId)
      );
    }
  });

const AllIcon = '/assets/icons/settings/all.svg';
const FavouriteIcon = '/assets/icons/settings/favourite.svg';
const ReadIcon = '/assets/icons/settings/read.svg';
const UnreadIcon = '/assets/icons/settings/unread.svg';

const MessageFilters = [
  {
    key: 'ALL',
    i18nKey: 'messageList.filters.All',
    selector: getAll,
    icon: AllIcon
  },
  {
    key: 'READ',
    i18nKey: 'messageList.filters.Read',
    selector: getRead,
    icon: ReadIcon
  },
  {
    key: 'UNREAD',
    i18nKey: 'messageList.filters.Unread',
    selector: getUnread,
    icon: UnreadIcon
  },
  {
    key: 'FLAGGED',
    i18nKey: 'messageList.filters.Favorites',
    selector: getFlagged,
    icon: FavouriteIcon
  },
  {
    key: 'USER_SEARCH',
    i18nKey: 'User_Search',
    selector: getUserSearch,
    icon: AllIcon // or create a search.svg icon
  }
].reduce((acc, mf) => {
  acc[mf.key] = mf;
  return acc;
}, {});

export const getFromKey = (key = null) => {
  if (key && MessageFilters[key]) {
    return MessageFilters[key];
  }
  return MessageFilters.ALL;
};

export default MessageFilters;
